import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  useTheme,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * 確認用モーダル（募集停止などに使える）
 *
 * @param {boolean} open - モーダルの表示状態
 * @param {function} onClose - 閉じる処理
 * @param {function} onConfirm - 確定処理
 * @param {string} title - モーダルタイトル
 * @param {string} message - 説明メッセージ
 * @param {string} confirmLabel - 確定ボタンの文言
 */
const ConfirmStopModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
}) => {
  const theme = useTheme();
  // モバイル判定
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: "bold" }}>{title}</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 1 }}>{message}</Typography>
        <Typography>実行してもよろしいですか？</Typography>
      </DialogContent>
      <DialogActions
        disableSpacing
        sx={{
          px: isMobile ? 1 : 3,
          pb: 2,
          gap: isMobile ? 2 : 2,
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "stretch" : "center",
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: 9999,
            px: isMobile ? 1 : 3,
            fontWeight: "bold",
            minWidth: isMobile ? "100%" : 120,
            minHeight: isMobile ? 56 : undefined,
            fontSize: isMobile ? "1rem" : undefined,
          }}
        >
          キャンセル
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            borderRadius: 9999,
            px: isMobile ? 1 : 3,
            fontWeight: "bold",
            bgcolor: "#000",
            color: "#fff",
            minWidth: isMobile ? "100%" : 140,
            minHeight: isMobile ? 56 : undefined,
            fontSize: isMobile ? "1rem" : undefined,
            "&:hover": { bgcolor: "#333" },
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmStopModal;
